import Airlines from "./Airlines";

export default Airlines;